import { Col, Row, Tabs } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllKorbaAssistance } from "../../../apis/actions/korba.actions";
import { toGetServices } from "../../../apis/actions/services.actions";
import { AppDispatch, RootState } from "../../../apis/store";
import ServiceCard from "../../../biblio/Cards/ServiceCard";
import DotsLoader from "../../../biblio/Loader/DotsLoader";
import ModalComponent from "../../../biblio/Modal/ModalComponent";
import ServicesRequestCard from "../../../components/card-request-beneficiary/ServicesRequestCard";
import PaginationComponent from "../../../biblio/Pagination/PaginationComponent";
import Selects from "../../../biblio/Selects/Selects";
import { getDateRange, scroll } from "../../../components/utils/utils";
import CustomConfigProvider from "../ProfileHeader";

const Services = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { services, loading, TotalBeneficiaryServices } = useSelector(
    (state: RootState) => state?.services
  );
  const { korbaAssitances } = useSelector((state: RootState) => state?.korbas);

  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedService, setSelectedService] = useState<any>();
  const [activeTab, setActiveTab] = useState<string>("available");
  const [state, setState] = useState({
    year: new Date().getFullYear().toString(),
    month: "",
  });

  const itemPerPage = 4;

  const showModal = (card: any) => {
    setSelectedService(card);
  };

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [state]);

  useEffect(() => {
    dispatch(getAllKorbaAssistance());
  }, [dispatch]);

  useEffect(() => {
    const { date_from, date_to } = getDateRange(state.year, state.month);

    dispatch(
      toGetServices({
        tag: activeTab,
        limit: itemPerPage,
        page: currentPage,
        assistance_id: selectedFilter,
        date_from,
        date_to,
      })
    );
  }, [dispatch, activeTab, currentPage, selectedFilter, state]);

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(value.value);
      setCurrentPage(1);
    } else {
      setSelectedFilter(null);
    }
  };

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    setCurrentPage(1);
  };

  const tabsData = [
    {
      key: "available",
      label: "متاح",
    },
    {
      key: "closed",
      label: "مغلق",
    },
    {
      key: "coming_soon",
      label: "قريبا",
    },
  ];

  return (
    <>
      <CustomConfigProvider
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
        title="الخدمات"
        YearValue={state.year}
      >
        <Selects
          options={korbaAssitances}
          selectPlaceholder="نوع الخدمة"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>

      <Tabs
        defaultActiveKey="available"
        activeKey={activeTab}
        onChange={handleTabChange}
        className="takaful--content-profile-tab takaful--registration beneficiary-services"
        items={tabsData.map(({ key, label }) => ({
          key,
          label: (
            <Row style={{ width: "100%" }}>
              <Col span={24}>
                <div className="tab-label">
                  <span className="tab-label-text">{label}</span>
                </div>
              </Col>
            </Row>
          ),
          children: (
            <>
              {loading ? (
                <div
                  className="takaful--loading-projects-cases"
                  style={{ marginTop: "3rem" }}
                >
                  <p className="takaful--no-project-message"> جارٍ التحميل</p>
                  <DotsLoader />
                </div>
              ) : services?.length === 0 && !selectedFilter ? (
                <div style={{ marginTop: "3rem" }}>
                  <p className="takaful--no-services">لا توجد خدمات</p>
                </div>
              ) : services?.length === 0 && selectedFilter ? (
                <div style={{ marginTop: "3rem" }}>
                  <p className="takaful--no-services">
                    لا يوجد خدمات تتوافق مع البحث الذي قمت به
                  </p>
                </div>
              ) : (
                <>
                  <Row
                    gutter={[64, 48]}
                    dir="rtl"
                    ref={currentRef}
                    style={{ marginTop: "3rem" }}
                  >
                    {services.map((card: any, index: number) => (
                      <Col
                        key={index}
                        xxl={12}
                        xl={12}
                        lg={12}
                        md={12}
                        sm={24}
                        xs={24}
                      >
                        <ServiceCard
                          open={() => showModal(card)}
                          card={card}
                          index={index}
                        />
                      </Col>
                    ))}
                  </Row>
                  <div className="takaful--pagination-container">
                    {services &&
                      Math.ceil(TotalBeneficiaryServices) * itemPerPage > itemPerPage && (
                        <PaginationComponent
                          active={currentPage}
                          total={Math.ceil(TotalBeneficiaryServices) * itemPerPage}
                          itemPerPage={itemPerPage}
                          scroll={() => scroll(currentRef)}
                          setActive={(nb) => updateActive(nb)}
                        />
                      )}
                  </div>
                </>
              )}
            </>
          ),
        }))}
      />

      {selectedService && (
        <ModalComponent
          title={""}
          open={selectedService !== null}
          closeOnOutsideClick={true}
          onClose={() => setSelectedService(null)}
          width={450}
          centered={true}
          modalStyle={{ top: "-8rem" }}
        >
          <ServicesRequestCard
            service={selectedService}
            setSelectedService={() => {
              scroll(currentRef);
              setSelectedService(null);
            }}
          />
        </ModalComponent>
      )}
    </>
  );
};

export default Services;
